export default __webpack_public_path__ + "static/media/Group 200.5e30ae5f.svg";